import React from "react"

const Label = React.forwardRef(({ className = "", htmlFor, ...props }, ref) => {
  return <label ref={ref} className={`text-sm font-medium leading-none ${className}`} htmlFor={htmlFor} {...props} />
})

Label.displayName = "Label"

export { Label }
